<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <div v-if="mode == 'search'">
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap">
                    <article class="srch_basic">
                        <div class="srch_grup">
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.FAQ.CORP') }}</li>
                                <li data-input-type="select" class="w100-150">
                                    <fieldset class="ui_fieldset set_2">
                                        <div>
                                            <select class="slt_white w100p" v-model="rhqCd" @change="changeRhqCd()">
                                                <option v-if="rhqCdList.length > 1" value selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                                <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </div>
                                        <div>
                                            <select class="slt_white w100p" v-model="corpNo">
                                                <option v-if="corpNoList.length != 1" value selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                                <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.FAST.STATUS') }}</li>
                                <li data-input-type="select" class="w100-150">
                                    <select class="slt_white w100" v-model="useYn">
                                        <option value selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option value="N">{{ $t('FIELD.GLOBAL.NO') }}</option>
                                        <option value="Y">{{ $t('FIELD.GLOBAL.YES') }}</option>
                                    </select>
                                </li>
                            </ul>
                            <!--Role ID-->
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.GLOBAL.ROLE.ID') }}</li>
                                <li data-input-type="text" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="authId" @keyup.enter.stop="onSearch(1)" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                            <ul class="w50">
                                <li class="tit_150">{{ $t('FIELD.GLOBAL.ROLE.NAME') }}</li>
                                <li data-input-type="text" class="w100-150">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="authNm" @keyup.enter.stop="onSearch(1)" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="srch_grupR">
                            <span class="btn">
                                <a href="JavaScript:" class="btn_srch" @click="clickSearch(1)">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                            </span>
                        </div>
                    </article>
                </div>

                <!-- Grid -->
                <div class="grid_wrap">
                    <!-- left: Total Count -->
                    <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
                    <!-- right: button area -->
                    <div class="btn_wrap">
                        <a href="JavaScript:" class="btn_gray" @click="clickCreate()" title>{{$t('BUTTON.GLOBAL.CREATE')}}</a>
                        <a href="javascript:" class="btn_white" @click="excelDownload()">{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                    </div>
                    <!-- Grid -->
                    <role-list-grid
                        :gridId="gridId"
                        :data="gridData"
                        :columns="columns"
                        :options="options"
                        :pageOptions="pageOptions"
                        :key="gridKey"
                        :click="contentClick"
                        :isTotalCount="false"
                        :menuMode="menuMode"
                    />
                </div>
            </div>
            <content-view v-if="mode !== 'search'" :pAuthCorpId="authCorpId" :pRhqCdList="rhqCdList" :pCorpNoList="corpNoList"></content-view>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import _ from 'lodash';
import $ from 'jquery';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import SDLPagination from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import ExcelDownloadPopup from '~vb/common/ExcelDownloadPopup';
import RoleListGrid from '~c/ToastGrid';
import RoleAdminView from './RoleAdminView';
import { mapGetters } from 'vuex';
import api from '@/service';

// ToastGrid UseYn Type renderer
class UseYnType {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        if (resVal == 'Y') resVal = 'Yes';
        else if (resVal == 'N') resVal = 'No';
        el.innerText = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
}

export default {
    name: 'RoleAdminList',
    props: {
        params: {},
    },
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'sdl-pagination': SDLPagination,
        'role-list-grid': RoleListGrid,
        'content-view': RoleAdminView,
    },
    data() {
        return {
            isLoading: true,
            mode: 'search', // 'view'
            loadingStatus: 'loading', // 'done', 'error'
            searchStatus: 'done', // 'loading', 'disabled'
            menuMode: 'ROLE',
            pageTitle: '',
            rhqCdList: [],
            corpNoList: [],
            authCorpId: '',
            authId: '',
            authNm: '',
            rhqCd: '',
            rhqCds: [],
            corpNo: '',
            useYn: '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            gridKey: 0,
            resultCount: 0,
            ORDER_COLUMN: '',
            ORDER_ASC: '',
            sortOrder: null, // ASC or DESC
            orgOrderCol: null,
            gridId: 'RoleAdminGrid',
            options: {},
            pageOptions: {},
            RoleTypes: [],
            gridData: [],
            searchFormData: {},
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ID'),
                    name: 'AUTH_ID',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.FAQ.CORP'),
                    name: 'SUBS_NM',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ROLE.NAME'),
                    name: 'AUTH_NM',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.USE.STATUS'),
                    name: 'USE_YN',
                    align: 'center',
                    renderer: { type: UseYnType },
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.REGISTER.DATE'),
                    name: 'REG_DT',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.REGISTER.USER'),
                    name: 'REG_USER_NO',
                    align: 'center',
                    sortable: true,
                },
            ],
            options: {
                scrollY: false,
                scrollX: false,
                rowHeight: 25,
            },
            pageOptions: {
                useClient: true,
                perPage: parseInt(localStorage.getItem('listRows') || 10),
            }
        };
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(mode, pCode, initMode) {
            if (mode == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.rhqCdList = data;
                    if (this.rhqCdList.length == 1) this.rhqCd = this.rhqCdList[0].code;
                    if (this.rhqCd) this.loadSubsiCodes(2, this.rhqCdList[0].code, initMode);
                    if (initMode) this.onSearch(1);
                });
            } else if (mode == 2) {
                // CorpNo
                this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                    this.corpNoList = data;
                    if (this.corpNoList.length == 1) this.corpNo = this.corpNoList[0].code;
                    else                             this.corpNo = '';
                });
            }
        },
        onSearch(pageNo) {
            if (!pageNo) pageNo = 1;

            const formData = this.prepSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            this.gridData = [];
            this.searchStatus = 'loading';
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/system/userRole/roleAdminList.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.resultCount = resp.data.totalCount;
                    this.gridData = resp.data.rows;

                    // Server에서 결과가 10개 미만일 때 항상 10을 돌려주는 문제를 임시적으로 해결하는 if문
                    if (
                        this.resultCount === 10 &&
                        typeof resp.data.rows !== 'undefined' &&
                        resp.data.rows.length < 10
                    ) {
                        this.resultCount = resp.data.rows.length;
                    }
                    this.searchStatus = 'done';
                    this.loadingStatus = 'done';

                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        changeRhqCd() {
            if (this.rhqCd == '') {
                this.corpNoList = [];
                this.corpNo = '';
            } else {
                this.loadSubsiCodes(2, this.rhqCd);
            }
        },
        // 그리드 row 클릭 시...
        clickCreate() {
            this.authCorpId = null;
            this.mode = 'view';
        },
        // 그리드 row 클릭 시... 상세페이지로 이동
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;
            SDLUtil.showLoadingBar(true);

            let item = this.gridData[event.rowKey];
            this.authCorpId = item.AUTH_CORP_ID;
            this.mode = 'view';

            window.scrollTo(0, 0);
            SDLUtil.showLoadingBar(false);
        },
        //
        prepSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;

            // rhqCd가 All일 때 권한내에 있는 CD로만 검색해야 함...
            this.rhqCds = [];
            if (!this.rhqCd) {
                this.rhqCdList.forEach(elm => {
                    this.rhqCds.push(elm.code);
                });
            } else { this.rhqCds = null; }

            let params = {
                page: pageNo,
                currentPage: pageNo,
                perPage: this.perPage,
                authId: this.authId,
                authNm: this.authNm,
                useYn: this.useYn,
                rhqCd: this.rhqCd,
                rhqCds: this.rhqCds,
                corpNo: this.corpNo,
                ORDER_COLUMN: this.ORDER_COLUMN,
                ORDER_ASC: this.ORDER_ASC,
            };
            return params;
        },

        clickSearch() {
            this.onSearch(1);
        }, // clickSearch
        goBackList(data) {
            this.onSearch(this.currentPage);
            this.mode = 'search';
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            this.ORDER_COLUMN = sortObj.columnName;

            if (this.ORDER_COLUMN != this.orgOrderCol) {
                this.sortOrder = null;
            }
            if (this.sortOrder == null) this.sortOrder = 'ASC';
            else if (this.sortOrder == 'ASC') this.sortOrder = 'DESC';
            else if (this.sortOrder == 'DESC') {
                this.sortOrder = null;
                this.ORDER_COLUMN = null;
            }

            this.ORDER_ASC = this.sortOrder;
            this.orgOrderCol = this.ORDER_COLUMN;
            this.onSearch(1);
        },
        // Excel Download
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    let formData = this.prepSearchParams(1);
                    formData.excelFile = 'RoleManagementList';
                    return axios
                      .post(
                          `${SDLUtil.API_URL}/basis/admin/system/userRole/roleManagementExcel.skp`,
                          qs.stringify(formData),
                      )
                      .then(resp => {
                          SDLUtil.showLoadingBar(false);
                          if (resp.data.EXCEL_FILES.length > 0) {
                              SDLUtil.show(
                                  ExcelDownloadPopup,
                                  {
                                      title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                      excelFiles: resp.data.excelFiles,
                                  },
                                  {
                                      height: 'auto',
                                  },
                              );
                          }
                          SDLUtil.showLoadingBar(false);
                      })
                      .catch(err => {
                          Vue.$log.error(err);
                          SDLUtil.errorAlert(err);
                          SDLUtil.showLoadingBar(false);
                      });
                },
            });
        },
    }, // methods
    created() {
        EventBus.$on('goRoleList', this.goBackList);
        EventBus.$on('sort-search-role', sortForm => {
            this.handleSortSearch(sortForm);
        });
    },
    mounted() {
        this.loadSubsiCodes(1, '', true);
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('goRoleList');
        EventBus.$off('sort-search-role');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/userRole/RoleAdminList.vue